// extracted by mini-css-extract-plugin
export default {"Container":"ColorPicker_Container__em4fB","Label":"ColorPicker_Label__Z5yZA","Test":"ColorPicker_Test__GJJJT"};